/*****************************************************************************/
/*  File Name: annualProfitDiffBar.js                                         */
/*  Date:      Aug 20, 2025                                                  */
/*  Author:    Ben Wakutz                                                    */
/*  Purpose:   This bar will hold the Estimated Annual Profit Difference     */
/*             moving it to a full length bar under the top charts           */
/*             for better visibility                                         */
/*                                                                           */
/*****************************************************************************/

import React from 'react';
import { withTranslation } from "react-i18next";
import { useROIContext } from '../../context/roiContext';
import { Grid } from '@mui/material';
import styles from './styles/roi.module.scss';
import { convertToCurrencyWithSymbol } from '../../functions/convertCurrency';



function AnnualProfitDiffBar({ t, compact = false }) {

    const {consumerAnnualTreatmenGrowthtProfit, totalAnnualProfit } = useROIContext();
    return(
        <Grid item xs={12} container className={`${styles.profitDifferenceBar} ${compact ? styles.compactProfitDifferenceBar : ''}`}>
            {!compact ? <Grid item xs={1}></Grid> : null}
            <Grid item xs={compact ? 12 : 4} className={styles.text}>
                Calculations only include treatment cost. Do not include capital expense.
            </Grid>
            <Grid item xs={compact ? 12 : 3} className={styles.title}>
                Estimated Annual Profit Difference: 
            </Grid>
            <Grid item xs={compact ? 12 : 2} >
                <span className={styles.value}>{convertToCurrencyWithSymbol(consumerAnnualTreatmenGrowthtProfit - totalAnnualProfit())}</span>
            </Grid>
            
            
        </Grid>
    )



}

export default withTranslation()(AnnualProfitDiffBar);
